import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subject, Subscription, combineLatest, iif } from 'rxjs';
import {ContextMembership, NetworkConstants, PointOfInterest} from 'diwimamodelweb/lib'
import { SettingsService } from './settings.service';
import { UserService } from './user.service';
import { TransactionLogService } from './transaction-log.service';
import { diffObject } from 'diwimamodelweb/lib/utils/obejct-diff';
import { take, takeUntil } from 'rxjs/operators';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib';
import { environment } from 'src/environments/environment';
import { Firestore, collection, collectionData, deleteDoc, deleteField, doc, getDocs, or, query, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { GeoPoint } from 'firebase/firestore';
import { applySharingFieldDeletes } from './context-rights-picker/sharing-fields';
import { preparePOTtoFirestore } from 'diwimamodelweb/src';
import { updatesToFirestoreUpdates } from './utils/utils';

@Injectable({
  providedIn: 'root'
})
export class PoiService {
  ngUnsubscribe: Subject<void> = new Subject<void>();
  private Ifirestore = inject(Firestore);
  subscriptions: Map<string, Subscription> = new Map([])

  poiSubject$ = new BehaviorSubject<PointOfInterest[]>(undefined)
  subbedContext: ContextMembership|undefined = undefined

  constructor(
    private settingsService: SettingsService,
    private userService: UserService,
    private transactionLogService: TransactionLogService
  ) {
    // this.settingsService.selectedUserContext$.subscribe((context) => {
    //   if (!context){ 
    //     this.subbedContext = undefined
    //     return 
    //   }
    //   if (this.subbedContext?.identifier == context.identifier) return 
    //   this.poiSubject$.next(undefined)
    //   if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    //   const sub = this.observePois(context.identifier)
    //   this.subscriptions.set('1', sub)
    //   this.subbedContext = context
    // })
  }

  observeData(dataFromIds) {
    // console.log('-- observeData POI --', this.subbedContext, dataFromIds)
    const contextId = this.settingsService.selectedUserContext$.value?.identifier

    if (this.subbedContext == dataFromIds) return 
    if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    if (!!this.poiSubject$.value) this.poiSubject$.next(undefined)
    const superOrsubContext = this.settingsService.superContext.value || this.settingsService.subContext.value

    if (superOrsubContext) {
      console.log('---observePoisContextAndContextIds---')
      const context = this.settingsService.selectedUserContext$.value
      const subIds = this.settingsService.getSubcontextIds()
      const sub = this.observePoisContextAndContextIds(contextId, subIds, context)
      this.subscriptions.set('1', sub)
    } else {
      console.log('---observePois---')
      const sub = this.observePois(contextId)
      this.subscriptions.set('1', sub)
    }

    this.subbedContext = superOrsubContext ? dataFromIds : contextId
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.subbedContext = undefined
    this.subscriptions.forEach((value) => {
      value.unsubscribe()
    })
    return Promise.resolve()
  }

  resetData() {
    this.poiSubject$.next(null)
  }

  observePois(contextId: string) {
    const path = `${NetworkConstants.COLLECTION_POI}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('contextId', '==', contextId))

    return collectionData(q)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((districts: any[]) => {
        var list: PointOfInterest[] = []
        districts.forEach((el) => {
          const district = new PointOfInterest()
          district.setFromAny(el)
          list.push(district)
        })
        this.poiSubject$.next(list)
      })
  }

  observePoisContextAndContextIds(contextId: string, contextIds: string[], context) {
    const collRef = collection(this.Ifirestore, NetworkConstants.COLLECTION_POI);
    const CHUNK_SIZE = 30;
    const qy$ = [];

    qy$.push(collectionData(query(collRef, where('contextId', '==', contextId))));
    qy$.push(collectionData(query(collRef, where('contextIds', 'array-contains', contextId))));

    if (contextIds?.length) {
      for (let i = 0; i < contextIds.length; i += CHUNK_SIZE) {
        const chunk = contextIds.slice(i, i + CHUNK_SIZE);
        qy$.push(collectionData(query(collRef, where('contextId', 'in', chunk))));
      }
    }

    return combineLatest(...qy$)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (results: any[][]) => {
          const byId = new Map<string, PointOfInterest>();
          results.flat().forEach((el: any) => {
            const poi = new PointOfInterest();
            poi.setFromAny(el);
            const id = (poi as any)?.identifier ?? el?.identifier;
            if (id && !byId.has(id)) {
              byId.set(id, poi);
            }
          });
          this.poiSubject$.next([...byId.values()]);
        },
        error: (err) => console.error('Firestore error:', err),
      });
  }
  
  updatePointOfInterest(oldPoi: PointOfInterest, newPoi: PointOfInterest): Promise<void> {
    return new Promise(async (resolve, reject) => {

      // Normalize locationCoordinates to GeoPoint so diffObject can compare them
      const normalizeGeoPoint = (poi: any) => {
        const loc = poi.locationCoordinates;
        if (loc && typeof loc.isEqual !== 'function' && loc.latitude != null && loc.longitude != null) {
          poi.locationCoordinates = new GeoPoint(loc.latitude, loc.longitude);
        }
      };
      normalizeGeoPoint(oldPoi as any);
      normalizeGeoPoint(newPoi as any);

      const updates = diffObject(oldPoi, newPoi, {})
      const map = updatesToFirestoreUpdates(updates)

      // Sanitize custom class instances
      // for (const key of Object.keys(map)) {
      //   const val = map[key];
      //   if (
      //     val !== null &&
      //     val !== undefined &&
      //     typeof val === 'object' &&
      //     !(val instanceof Date) &&
      //     !(val instanceof GeoPoint) &&
      //     !Array.isArray(val) &&
      //     val.constructor !== Object
      //   ) {
      //     const num = Number(val);
      //     map[key] = isNaN(num) ? null : num;
      //   }
      // }

      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newPoi.identifier, NetworkConstants.COLLECTION_POI)
        map['updateTimestamp'] = new Date()
        applySharingFieldDeletes(map, oldPoi as any, newPoi as any)
        const newChannels = (newPoi as any).notificationChannel
        map['notificationChannel'] = Array.isArray(newChannels) && newChannels.length
          ? newChannels
          : deleteField()
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_POI, newPoi.identifier)
        await updateDoc(docRef, map)
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  async createPointOfInterest(poi: PointOfInterest): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise();
        const contextId = this.settingsService.selectedUserContext$?.value?.identifier ?? user?.uid;
        const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_POI))

        // Generate a new identifier if not set
        if (!poi.identifier) {
          poi.identifier = docRef.id // or uuidv4()
        }

        poi.contextId   = contextId;
        poi.creationDate = new Date();
        poi.updateTimestamp = new Date();

        const plain: any = {};
        for (const key of Object.keys(poi)) {
          if (['context', 'className'].includes(key)) continue;
          const val = (poi as any)[key];
          if (val !== undefined) plain[key] = val;
        }

        const logItems = this.transactionLogService.createLog(user, poi.identifier, NetworkConstants.COLLECTION_POI, plain)
        await setDoc(docRef, plain);
        await this.transactionLogService.saveTransactionLog(logItems)

        const current = this.poiSubject$.value ?? [];
        this.poiSubject$.next([...current, poi]);

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  createPoinOfInterest(newPoi: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_POI))
      const now = new Date()
      newPoi['identifier'] = docRef.id
      newPoi['creationDate'] = now
      newPoi['updateTimestamp'] = now
      removeUndefined(newPoi)
      try {
        const contextId = this.settingsService.selectedUserContext$.value.identifier
        if (!contextId) reject("No context id")
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const logItems = this.transactionLogService.createLog(user, newPoi.identifier, NetworkConstants.COLLECTION_POI, newPoi)
        newPoi['contextId'] = contextId

        await setDoc(docRef,{...newPoi} )
        await this.transactionLogService.saveTransactionLog(logItems)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  async loadPointOfInteresPictureURLlinks(poiId){
    return new Promise(async (resolve, reject) => {
      const collRef = collection(this.Ifirestore, `${NetworkConstants.COLLECTION_POINT_OF_INTEREST}/${poiId}/Image`)
      const results = await getDocs(collRef);

      if (!results.empty) {
        const imagesToAdd = results.docs.map( (doc, index) => {
          const data = doc.data()
          const identifier = data?.identifier
          const id = doc.id
          let nurl, preview
          const preview_img = identifier.match(/preview_(.+).jpg/)

          if(preview_img && preview_img[1]){
            nurl= new URL(`${environment.apiURL}/pointOfInterest/${poiId}/images/${id}.jpeg`)
            preview = new URL(`${environment.apiURL}/pointOfInterest/${poiId}/images/${id}.jpeg`)
          }else{
            nurl = new URL(`${environment.apiURL}/pointOfInterest/${poiId}/images/${identifier}.jpeg`)
            preview = new URL(`${environment.apiURL}/pointOfInterest/${poiId}/images/${identifier}.jpeg`)
          }
          return nurl.href
        })
        resolve(imagesToAdd)
      }else{
        reject()
      }
    })
  }

  deletePointOfInterest(poi: PointOfInterest): Promise<void>{
    return new Promise(async (resolve, reject) => {
      try{
        const poiToDelete = deepCopy(poi, poi.replacerFn)
        const dataToDelete = removeUndefined(poiToDelete)

        const plain = preparePOTtoFirestore(poi)
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const transactionLogItem = this.transactionLogService.deleteDocumentLog(
          user,
          poi.identifier,
          NetworkConstants.COLLECTION_POI,
          plain
        )
        const promiseArray = []
        promiseArray.push(
          this.transactionLogService.saveTransactionLog([transactionLogItem])
        )
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_POI, poi.identifier)
        const delOperation = await deleteDoc( docRef)
        promiseArray.push(delOperation)
        resolve()
      }catch(error){
        reject(error)
        console.log(error)
      }
    })
  }
}
